// extracted by mini-css-extract-plugin
export default {"container":"OfftimeHorizontal-module_container_qPoqF","content":"OfftimeHorizontal-module_content_LhYcr"};